import _slicedToArray from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }

function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

function _classStaticPrivateMethodGet(receiver, classConstructor, method) { _classCheckPrivateStaticAccess(receiver, classConstructor); return method; }

function _classCheckPrivateStaticAccess(receiver, classConstructor) { if (receiver !== classConstructor) { throw new TypeError("Private static access of wrong provenance"); } }

// parse a single path portion
import { parseClass } from './brace-expressions.js';
import { unescape } from './unescape.js';
var types = new Set(['!', '?', '+', '*', '@']);

var isExtglobType = function isExtglobType(c) {
  return types.has(c);
}; // Patterns that get prepended to bind to the start of either the
// entire string, or just a single path portion, to prevent dots
// and/or traversal patterns, when needed.
// Exts don't need the ^ or / bit, because the root binds that already.


var startNoTraversal = '(?!(?:^|/)\\.\\.?(?:$|/))';
var startNoDot = '(?!\\.)'; // characters that indicate a start of pattern needs the "no dots" bit,
// because a dot *might* be matched. ( is not in the list, because in
// the case of a child extglob, it will handle the prevention itself.

var addPatternStart = new Set(['[', '.']); // cases where traversal is A-OK, no dot prevention needed

var justDots = new Set(['..', '.']);
var reSpecials = new Set('().*{}+?[]^$\\!');

var regExpEscape = function regExpEscape(s) {
  return s.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}; // any single thing other than /


var qmark = '[^/]'; // * => any number of characters

var star = qmark + '*?'; // use + when we need to ensure that *something* matches, because the * is
// the only thing in the path portion.

var starNoEmpty = qmark + '+?'; // remove the \ chars that we added if we end up doing a nonmagic compare
// const deslash = (s: string) => s.replace(/\\(.)/g, '$1')

var _root = /*#__PURE__*/new WeakMap();

var _hasMagic2 = /*#__PURE__*/new WeakMap();

var _uflag = /*#__PURE__*/new WeakMap();

var _parts = /*#__PURE__*/new WeakMap();

var _parent = /*#__PURE__*/new WeakMap();

var _parentIndex = /*#__PURE__*/new WeakMap();

var _negs = /*#__PURE__*/new WeakMap();

var _filledNegs = /*#__PURE__*/new WeakMap();

var _options = /*#__PURE__*/new WeakMap();

var _toString = /*#__PURE__*/new WeakMap();

var _emptyExt = /*#__PURE__*/new WeakMap();

var _fillNegs = /*#__PURE__*/new WeakSet();

var _partsToRegExp = /*#__PURE__*/new WeakSet();

export var AST = /*#__PURE__*/function () {
  // set to true if it's an extglob with no children
  // (which really means one child of '')
  function AST(type, parent) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, AST);

    _classPrivateMethodInitSpec(this, _partsToRegExp);

    _classPrivateMethodInitSpec(this, _fillNegs);

    _defineProperty(this, "type", void 0);

    _classPrivateFieldInitSpec(this, _root, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _hasMagic2, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _uflag, {
      writable: true,
      value: false
    });

    _classPrivateFieldInitSpec(this, _parts, {
      writable: true,
      value: []
    });

    _classPrivateFieldInitSpec(this, _parent, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _parentIndex, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _negs, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _filledNegs, {
      writable: true,
      value: false
    });

    _classPrivateFieldInitSpec(this, _options, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _toString, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _emptyExt, {
      writable: true,
      value: false
    });

    this.type = type; // extglobs are inherently magical

    if (type) _classPrivateFieldSet(this, _hasMagic2, true);

    _classPrivateFieldSet(this, _parent, parent);

    _classPrivateFieldSet(this, _root, _classPrivateFieldGet(this, _parent) ? _classPrivateFieldGet(_classPrivateFieldGet(this, _parent), _root) : this);

    _classPrivateFieldSet(this, _options, _classPrivateFieldGet(this, _root) === this ? options : _classPrivateFieldGet(_classPrivateFieldGet(this, _root), _options));

    _classPrivateFieldSet(this, _negs, _classPrivateFieldGet(this, _root) === this ? [] : _classPrivateFieldGet(_classPrivateFieldGet(this, _root), _negs));

    if (type === '!' && !_classPrivateFieldGet(_classPrivateFieldGet(this, _root), _filledNegs)) _classPrivateFieldGet(this, _negs).push(this);

    _classPrivateFieldSet(this, _parentIndex, _classPrivateFieldGet(this, _parent) ? _classPrivateFieldGet(_classPrivateFieldGet(this, _parent), _parts).length : 0);
  }

  _createClass(AST, [{
    key: "hasMagic",
    get: function get() {
      /* c8 ignore start */
      if (_classPrivateFieldGet(this, _hasMagic2) !== undefined) return _classPrivateFieldGet(this, _hasMagic2);
      /* c8 ignore stop */

      var _iterator = _createForOfIteratorHelper(_classPrivateFieldGet(this, _parts)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var p = _step.value;
          if (typeof p === 'string') continue;
          if (p.type || p.hasMagic) return _classPrivateFieldSet(this, _hasMagic2, true);
        } // note: will be undefined until we generate the regexp src and find out

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return _classPrivateFieldGet(this, _hasMagic2);
    } // reconstructs the pattern

  }, {
    key: "toString",
    value: function toString() {
      if (_classPrivateFieldGet(this, _toString) !== undefined) return _classPrivateFieldGet(this, _toString);

      if (!this.type) {
        return _classPrivateFieldSet(this, _toString, _classPrivateFieldGet(this, _parts).map(function (p) {
          return String(p);
        }).join(''));
      } else {
        return _classPrivateFieldSet(this, _toString, this.type + '(' + _classPrivateFieldGet(this, _parts).map(function (p) {
          return String(p);
        }).join('|') + ')');
      }
    }
  }, {
    key: "push",
    value: function push() {
      for (var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++) {
        parts[_key] = arguments[_key];
      }

      for (var _i = 0, _parts2 = parts; _i < _parts2.length; _i++) {
        var p = _parts2[_i];
        if (p === '') continue;
        /* c8 ignore start */

        if (typeof p !== 'string' && !(p instanceof AST && _classPrivateFieldGet(p, _parent) === this)) {
          throw new Error('invalid part: ' + p);
        }
        /* c8 ignore stop */


        _classPrivateFieldGet(this, _parts).push(p);
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var _classPrivateFieldGet2;

      var ret = this.type === null ? _classPrivateFieldGet(this, _parts).slice().map(function (p) {
        return typeof p === 'string' ? p : p.toJSON();
      }) : [this.type].concat(_toConsumableArray(_classPrivateFieldGet(this, _parts).map(function (p) {
        return p.toJSON();
      })));
      if (this.isStart() && !this.type) ret.unshift([]);

      if (this.isEnd() && (this === _classPrivateFieldGet(this, _root) || _classPrivateFieldGet(_classPrivateFieldGet(this, _root), _filledNegs) && ((_classPrivateFieldGet2 = _classPrivateFieldGet(this, _parent)) === null || _classPrivateFieldGet2 === void 0 ? void 0 : _classPrivateFieldGet2.type) === '!')) {
        ret.push({});
      }

      return ret;
    }
  }, {
    key: "isStart",
    value: function isStart() {
      var _classPrivateFieldGet3;

      if (_classPrivateFieldGet(this, _root) === this) return true; // if (this.type) return !!this.#parent?.isStart()

      if (!((_classPrivateFieldGet3 = _classPrivateFieldGet(this, _parent)) !== null && _classPrivateFieldGet3 !== void 0 && _classPrivateFieldGet3.isStart())) return false;
      if (_classPrivateFieldGet(this, _parentIndex) === 0) return true; // if everything AHEAD of this is a negation, then it's still the "start"

      var p = _classPrivateFieldGet(this, _parent);

      for (var i = 0; i < _classPrivateFieldGet(this, _parentIndex); i++) {
        var pp = _classPrivateFieldGet(p, _parts)[i];

        if (!(pp instanceof AST && pp.type === '!')) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "isEnd",
    value: function isEnd() {
      var _classPrivateFieldGet4, _classPrivateFieldGet5, _classPrivateFieldGet6;

      if (_classPrivateFieldGet(this, _root) === this) return true;
      if (((_classPrivateFieldGet4 = _classPrivateFieldGet(this, _parent)) === null || _classPrivateFieldGet4 === void 0 ? void 0 : _classPrivateFieldGet4.type) === '!') return true;
      if (!((_classPrivateFieldGet5 = _classPrivateFieldGet(this, _parent)) !== null && _classPrivateFieldGet5 !== void 0 && _classPrivateFieldGet5.isEnd())) return false;
      if (!this.type) return (_classPrivateFieldGet6 = _classPrivateFieldGet(this, _parent)) === null || _classPrivateFieldGet6 === void 0 ? void 0 : _classPrivateFieldGet6.isEnd(); // if not root, it'll always have a parent

      /* c8 ignore start */

      var pl = _classPrivateFieldGet(this, _parent) ? _classPrivateFieldGet(_classPrivateFieldGet(this, _parent), _parts).length : 0;
      /* c8 ignore stop */

      return _classPrivateFieldGet(this, _parentIndex) === pl - 1;
    }
  }, {
    key: "copyIn",
    value: function copyIn(part) {
      if (typeof part === 'string') this.push(part);else this.push(part.clone(this));
    }
  }, {
    key: "clone",
    value: function clone(parent) {
      var c = new AST(this.type, parent);

      var _iterator2 = _createForOfIteratorHelper(_classPrivateFieldGet(this, _parts)),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var p = _step2.value;
          c.copyIn(p);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return c;
    }
  }, {
    key: "toMMPattern",
    value: // returns the regular expression if there's magic, or the unescaped
    // string if not.
    function toMMPattern() {
      // should only be called on root

      /* c8 ignore start */
      if (this !== _classPrivateFieldGet(this, _root)) return _classPrivateFieldGet(this, _root).toMMPattern();
      /* c8 ignore stop */

      var glob = this.toString();

      var _this$toRegExpSource = this.toRegExpSource(),
          _this$toRegExpSource2 = _slicedToArray(_this$toRegExpSource, 4),
          re = _this$toRegExpSource2[0],
          body = _this$toRegExpSource2[1],
          hasMagic = _this$toRegExpSource2[2],
          uflag = _this$toRegExpSource2[3]; // if we're in nocase mode, and not nocaseMagicOnly, then we do
      // still need a regular expression if we have to case-insensitively
      // match capital/lowercase characters.


      var anyMagic = hasMagic || _classPrivateFieldGet(this, _hasMagic2) || _classPrivateFieldGet(this, _options).nocase && !_classPrivateFieldGet(this, _options).nocaseMagicOnly && glob.toUpperCase() !== glob.toLowerCase();

      if (!anyMagic) {
        return body;
      }

      var flags = (_classPrivateFieldGet(this, _options).nocase ? 'i' : '') + (uflag ? 'u' : '');
      return Object.assign(new RegExp("^".concat(re, "$"), flags), {
        _src: re,
        _glob: glob
      });
    } // returns the string match, the regexp source, whether there's magic
    // in the regexp (so a regular expression is required) and whether or
    // not the uflag is needed for the regular expression (for posix classes)
    // TODO: instead of injecting the start/end at this point, just return
    // the BODY of the regexp, along with the start/end portions suitable
    // for binding the start/end in either a joined full-path makeRe context
    // (where we bind to (^|/), or a standalone matchPart context (where
    // we bind to ^, and not /).  Otherwise slashes get duped!
    //
    // In part-matching mode, the start is:
    // - if not isStart: nothing
    // - if traversal possible, but not allowed: ^(?!\.\.?$)
    // - if dots allowed or not possible: ^
    // - if dots possible and not allowed: ^(?!\.)
    // end is:
    // - if not isEnd(): nothing
    // - else: $
    //
    // In full-path matching mode, we put the slash at the START of the
    // pattern, so start is:
    // - if first pattern: same as part-matching mode
    // - if not isStart(): nothing
    // - if traversal possible, but not allowed: /(?!\.\.?(?:$|/))
    // - if dots allowed or not possible: /
    // - if dots possible and not allowed: /(?!\.)
    // end is:
    // - if last pattern, same as part-matching mode
    // - else nothing
    //
    // Always put the (?:$|/) on negated tails, though, because that has to be
    // there to bind the end of the negated pattern portion, and it's easier to
    // just stick it in now rather than try to inject it later in the middle of
    // the pattern.
    //
    // We can just always return the same end, and leave it up to the caller
    // to know whether it's going to be used joined or in parts.
    // And, if the start is adjusted slightly, can do the same there:
    // - if not isStart: nothing
    // - if traversal possible, but not allowed: (?:/|^)(?!\.\.?$)
    // - if dots allowed or not possible: (?:/|^)
    // - if dots possible and not allowed: (?:/|^)(?!\.)
    //
    // But it's better to have a simpler binding without a conditional, for
    // performance, so probably better to return both start options.
    //
    // Then the caller just ignores the end if it's not the first pattern,
    // and the start always gets applied.
    //
    // But that's always going to be $ if it's the ending pattern, or nothing,
    // so the caller can just attach $ at the end of the pattern when building.
    //
    // So the todo is:
    // - better detect what kind of start is needed
    // - return both flavors of starting pattern
    // - attach $ at the end of the pattern when creating the actual RegExp
    //
    // Ah, but wait, no, that all only applies to the root when the first pattern
    // is not an extglob. If the first pattern IS an extglob, then we need all
    // that dot prevention biz to live in the extglob portions, because eg
    // +(*|.x*) can match .xy but not .yx.
    //
    // So, return the two flavors if it's #root and the first child is not an
    // AST, otherwise leave it to the child AST to handle it, and there,
    // use the (?:^|/) style of start binding.
    //
    // Even simplified further:
    // - Since the start for a join is eg /(?!\.) and the start for a part
    // is ^(?!\.), we can just prepend (?!\.) to the pattern (either root
    // or start or whatever) and prepend ^ or / at the Regexp construction.

  }, {
    key: "toRegExpSource",
    value: function toRegExpSource(allowDot) {
      var _this = this;

      var dot = allowDot !== null && allowDot !== void 0 ? allowDot : !!_classPrivateFieldGet(this, _options).dot;
      if (_classPrivateFieldGet(this, _root) === this) _classPrivateMethodGet(this, _fillNegs, _fillNegs2).call(this);

      if (!this.type) {
        var _classPrivateFieldGet7;

        var noEmpty = this.isStart() && this.isEnd();

        var src = _classPrivateFieldGet(this, _parts).map(function (p) {
          var _ref = typeof p === 'string' ? _classStaticPrivateMethodGet(AST, AST, _parseGlob).call(AST, p, _classPrivateFieldGet(_this, _hasMagic2), noEmpty) : p.toRegExpSource(allowDot),
              _ref2 = _slicedToArray(_ref, 4),
              re = _ref2[0],
              _ = _ref2[1],
              hasMagic = _ref2[2],
              uflag = _ref2[3];

          _classPrivateFieldSet(_this, _hasMagic2, _classPrivateFieldGet(_this, _hasMagic2) || hasMagic);

          _classPrivateFieldSet(_this, _uflag, _classPrivateFieldGet(_this, _uflag) || uflag);

          return re;
        }).join('');

        var _start = '';

        if (this.isStart()) {
          if (typeof _classPrivateFieldGet(this, _parts)[0] === 'string') {
            // this is the string that will match the start of the pattern,
            // so we need to protect against dots and such.
            // '.' and '..' cannot match unless the pattern is that exactly,
            // even if it starts with . or dot:true is set.
            var dotTravAllowed = _classPrivateFieldGet(this, _parts).length === 1 && justDots.has(_classPrivateFieldGet(this, _parts)[0]);

            if (!dotTravAllowed) {
              var aps = addPatternStart; // check if we have a possibility of matching . or ..,
              // and prevent that.

              var needNoTrav = // dots are allowed, and the pattern starts with [ or .
              dot && aps.has(src.charAt(0)) || // the pattern starts with \., and then [ or .
              src.startsWith('\\.') && aps.has(src.charAt(2)) || // the pattern starts with \.\., and then [ or .
              src.startsWith('\\.\\.') && aps.has(src.charAt(4)); // no need to prevent dots if it can't match a dot, or if a
              // sub-pattern will be preventing it anyway.

              var needNoDot = !dot && !allowDot && aps.has(src.charAt(0));
              _start = needNoTrav ? startNoTraversal : needNoDot ? startNoDot : '';
            }
          }
        } // append the "end of path portion" pattern to negation tails


        var end = '';

        if (this.isEnd() && _classPrivateFieldGet(_classPrivateFieldGet(this, _root), _filledNegs) && ((_classPrivateFieldGet7 = _classPrivateFieldGet(this, _parent)) === null || _classPrivateFieldGet7 === void 0 ? void 0 : _classPrivateFieldGet7.type) === '!') {
          end = '(?:$|\\/)';
        }

        var _final = _start + src + end;

        return [_final, unescape(src), _classPrivateFieldSet(this, _hasMagic2, !!_classPrivateFieldGet(this, _hasMagic2)), _classPrivateFieldGet(this, _uflag)];
      } // We need to calculate the body *twice* if it's a repeat pattern
      // at the start, once in nodot mode, then again in dot mode, so a
      // pattern like *(?) can match 'x.y'


      var repeated = this.type === '*' || this.type === '+'; // some kind of extglob

      var start = this.type === '!' ? '(?:(?!(?:' : '(?:';

      var body = _classPrivateMethodGet(this, _partsToRegExp, _partsToRegExp2).call(this, dot);

      if (this.isStart() && this.isEnd() && !body && this.type !== '!') {
        // invalid extglob, has to at least be *something* present, if it's
        // the entire path portion.
        var s = this.toString();

        _classPrivateFieldSet(this, _parts, [s]);

        this.type = null;

        _classPrivateFieldSet(this, _hasMagic2, undefined);

        return [s, unescape(this.toString()), false, false];
      } // XXX abstract out this map method


      var bodyDotAllowed = !repeated || allowDot || dot || !startNoDot ? '' : _classPrivateMethodGet(this, _partsToRegExp, _partsToRegExp2).call(this, true);

      if (bodyDotAllowed === body) {
        bodyDotAllowed = '';
      }

      if (bodyDotAllowed) {
        body = "(?:".concat(body, ")(?:").concat(bodyDotAllowed, ")*?");
      } // an empty !() is exactly equivalent to a starNoEmpty


      var final = '';

      if (this.type === '!' && _classPrivateFieldGet(this, _emptyExt)) {
        final = (this.isStart() && !dot ? startNoDot : '') + starNoEmpty;
      } else {
        var close = this.type === '!' ? // !() must match something,but !(x) can match ''
        '))' + (this.isStart() && !dot && !allowDot ? startNoDot : '') + star + ')' : this.type === '@' ? ')' : this.type === '?' ? ')?' : this.type === '+' && bodyDotAllowed ? ')' : this.type === '*' && bodyDotAllowed ? ")?" : ")".concat(this.type);
        final = start + body + close;
      }

      return [final, unescape(body), _classPrivateFieldSet(this, _hasMagic2, !!_classPrivateFieldGet(this, _hasMagic2)), _classPrivateFieldGet(this, _uflag)];
    }
  }], [{
    key: "fromGlob",
    value: function fromGlob(pattern) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var ast = new AST(null, undefined, options);

      _classStaticPrivateMethodGet(AST, AST, _parseAST).call(AST, pattern, ast, 0, options);

      return ast;
    }
  }]);

  return AST;
}();

function _fillNegs2() {
  /* c8 ignore start */
  if (this !== _classPrivateFieldGet(this, _root)) throw new Error('should only call on root');
  if (_classPrivateFieldGet(this, _filledNegs)) return this;
  /* c8 ignore stop */
  // call toString() once to fill this out

  this.toString();

  _classPrivateFieldSet(this, _filledNegs, true);

  var n;

  while (n = _classPrivateFieldGet(this, _negs).pop()) {
    if (n.type !== '!') continue; // walk up the tree, appending everthing that comes AFTER parentIndex

    var p = n;

    var pp = _classPrivateFieldGet(p, _parent);

    while (pp) {
      for (var i = _classPrivateFieldGet(p, _parentIndex) + 1; !pp.type && i < _classPrivateFieldGet(pp, _parts).length; i++) {
        var _iterator3 = _createForOfIteratorHelper(_classPrivateFieldGet(n, _parts)),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var part = _step3.value;

            /* c8 ignore start */
            if (typeof part === 'string') {
              throw new Error('string part in extglob AST??');
            }
            /* c8 ignore stop */


            part.copyIn(_classPrivateFieldGet(pp, _parts)[i]);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }

      p = pp;
      pp = _classPrivateFieldGet(p, _parent);
    }
  }

  return this;
}

function _parseAST(str, ast, pos, opt) {
  var escaping = false;
  var inBrace = false;
  var braceStart = -1;
  var braceNeg = false;

  if (ast.type === null) {
    // outside of a extglob, append until we find a start
    var _i2 = pos;
    var _acc = '';

    while (_i2 < str.length) {
      var c = str.charAt(_i2++); // still accumulate escapes at this point, but we do ignore
      // starts that are escaped

      if (escaping || c === '\\') {
        escaping = !escaping;
        _acc += c;
        continue;
      }

      if (inBrace) {
        if (_i2 === braceStart + 1) {
          if (c === '^' || c === '!') {
            braceNeg = true;
          }
        } else if (c === ']' && !(_i2 === braceStart + 2 && braceNeg)) {
          inBrace = false;
        }

        _acc += c;
        continue;
      } else if (c === '[') {
        inBrace = true;
        braceStart = _i2;
        braceNeg = false;
        _acc += c;
        continue;
      }

      if (!opt.noext && isExtglobType(c) && str.charAt(_i2) === '(') {
        ast.push(_acc);
        _acc = '';
        var ext = new AST(c, ast);
        _i2 = _classStaticPrivateMethodGet(AST, AST, _parseAST).call(AST, str, ext, _i2, opt);
        ast.push(ext);
        continue;
      }

      _acc += c;
    }

    ast.push(_acc);
    return _i2;
  } // some kind of extglob, pos is at the (
  // find the next | or )


  var i = pos + 1;
  var part = new AST(null, ast);
  var parts = [];
  var acc = '';

  while (i < str.length) {
    var _c = str.charAt(i++); // still accumulate escapes at this point, but we do ignore
    // starts that are escaped


    if (escaping || _c === '\\') {
      escaping = !escaping;
      acc += _c;
      continue;
    }

    if (inBrace) {
      if (i === braceStart + 1) {
        if (_c === '^' || _c === '!') {
          braceNeg = true;
        }
      } else if (_c === ']' && !(i === braceStart + 2 && braceNeg)) {
        inBrace = false;
      }

      acc += _c;
      continue;
    } else if (_c === '[') {
      inBrace = true;
      braceStart = i;
      braceNeg = false;
      acc += _c;
      continue;
    }

    if (isExtglobType(_c) && str.charAt(i) === '(') {
      part.push(acc);
      acc = '';

      var _ext = new AST(_c, part);

      part.push(_ext);
      i = _classStaticPrivateMethodGet(AST, AST, _parseAST).call(AST, str, _ext, i, opt);
      continue;
    }

    if (_c === '|') {
      part.push(acc);
      acc = '';
      parts.push(part);
      part = new AST(null, ast);
      continue;
    }

    if (_c === ')') {
      if (acc === '' && _classPrivateFieldGet(ast, _parts).length === 0) {
        _classPrivateFieldSet(ast, _emptyExt, true);
      }

      part.push(acc);
      acc = '';
      ast.push.apply(ast, parts.concat([part]));
      return i;
    }

    acc += _c;
  } // unfinished extglob
  // if we got here, it was a malformed extglob! not an extglob, but
  // maybe something else in there.


  ast.type = null;

  _classPrivateFieldSet(ast, _hasMagic2, undefined);

  _classPrivateFieldSet(ast, _parts, [str.substring(pos - 1)]);

  return i;
}

function _partsToRegExp2(dot) {
  var _this2 = this;

  return _classPrivateFieldGet(this, _parts).map(function (p) {
    // extglob ASTs should only contain parent ASTs

    /* c8 ignore start */
    if (typeof p === 'string') {
      throw new Error('string type in extglob ast??');
    }
    /* c8 ignore stop */
    // can ignore hasMagic, because extglobs are already always magic


    var _p$toRegExpSource = p.toRegExpSource(dot),
        _p$toRegExpSource2 = _slicedToArray(_p$toRegExpSource, 4),
        re = _p$toRegExpSource2[0],
        _ = _p$toRegExpSource2[1],
        _hasMagic = _p$toRegExpSource2[2],
        uflag = _p$toRegExpSource2[3];

    _classPrivateFieldSet(_this2, _uflag, _classPrivateFieldGet(_this2, _uflag) || uflag);

    return re;
  }).filter(function (p) {
    return !(_this2.isStart() && _this2.isEnd()) || !!p;
  }).join('|');
}

function _parseGlob(glob, hasMagic) {
  var noEmpty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var escaping = false;
  var re = '';
  var uflag = false;

  for (var i = 0; i < glob.length; i++) {
    var c = glob.charAt(i);

    if (escaping) {
      escaping = false;
      re += (reSpecials.has(c) ? '\\' : '') + c;
      continue;
    }

    if (c === '\\') {
      if (i === glob.length - 1) {
        re += '\\\\';
      } else {
        escaping = true;
      }

      continue;
    }

    if (c === '[') {
      var _parseClass = parseClass(glob, i),
          _parseClass2 = _slicedToArray(_parseClass, 4),
          src = _parseClass2[0],
          needUflag = _parseClass2[1],
          consumed = _parseClass2[2],
          magic = _parseClass2[3];

      if (consumed) {
        re += src;
        uflag = uflag || needUflag;
        i += consumed - 1;
        hasMagic = hasMagic || magic;
        continue;
      }
    }

    if (c === '*') {
      if (noEmpty && glob === '*') re += starNoEmpty;else re += star;
      hasMagic = true;
      continue;
    }

    if (c === '?') {
      re += qmark;
      hasMagic = true;
      continue;
    }

    re += regExpEscape(c);
  }

  return [re, unescape(glob), !!hasMagic, uflag];
}